<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 408.8 408.8"
    style="enable-background: new 0 0 408.8 408.8"
    xml:space="preserve"
  >
    <path
      class="st10"
      d="M0.4,332.1h408v-42.6H0.4V332.1z M0.4,225.7h408v-42.6H0.4V225.7z M0.4,76.6v42.6h408V76.6H0.4z"
    />
  </svg>
</template>

<style type="text/css" scoped>
.st10 {
  fill: #ffffff;
}
</style>
